import { PARAMETER_ID_TOKEN } from "src/Utilities/constants";

/**
 * Checks query string for ID Token parameter. Returns null if not found
 * @returns String || Null
 */
const checkQS = () => {
    const qs = new URLSearchParams(window.location.search);
    const idToken = qs.get(PARAMETER_ID_TOKEN);

    return idToken;

};

/**
 * Parses query string's goto url paramter for ID Token parameter. Returns null if not found
 * @returns String || Null
 */
const checkGoto = () => {
    const qs = new URLSearchParams(window.location.search);
    const goto = qs.get("goto");
    
    if (goto) {
        const gotoUrl = new URL(qs.get("goto"));
        const idToken = new URLSearchParams(gotoUrl.search).get(PARAMETER_ID_TOKEN);

        return idToken;
    }

    return null;
};

const idTokenMiddleware = (req, action, next) => {
    let headers;
    let idToken = checkQS();

    function addHeaders(token) {
        headers = req.init.headers;
        headers.append("X-subject-token", token);
    }

    if (idToken) {
        addHeaders(idToken);
    }
    else {
        idToken = checkGoto();

        if (idToken) {
            addHeaders(idToken);
        }
    }

    next();
};

export default idTokenMiddleware;